import React from "react";
import ServicePageShell from "../components/ServicePageShell";
import { createBreadcrumbList } from "../utils/seo";

const TermsOfService = () => {
  const schemas = [
    createBreadcrumbList([
      { name: "Home", path: "/" },
      { name: "Terms of Service", path: "/terms-of-service" },
    ]),
  ];

  return (
    <ServicePageShell
      title="Terms of Service | QBits9"
      description="Read the terms under which QBits9 provides AI automation, custom software, ERP integration, and related technical services."
      canonicalPath="/terms-of-service"
      keywords="terms of service QBits9, service terms, software development agreement"
      schemas={schemas}
    >
      <section className="relative overflow-hidden bg-white">
        <div className="mx-auto max-w-7xl px-5 py-16 md:py-24 lg:px-16">
          <div className="space-y-8">
            <span className="font-peachi text-[16px] md:text-[18px] text-black font-[500] mb-3">
              Terms of service
            </span>
            <h1 className="text-black xl:text-[58px] lg:text-[50px] md:text-[42px] text-[28px] font-bold leading-[1.2]">
              QBits9 Terms of Service
            </h1>
            <p className="max-w-3xl text-lg leading-8 text-slate-600 font-poppins">
              These terms explain how QBits9 provides services, how we work with clients, and what to expect when you engage us for automation, software, or integration projects.
            </p>
          </div>

          <div className="mt-12 space-y-12 text-slate-700 font-poppins">
            <section>
              <h2 className="text-2xl font-semibold text-slate-900 mb-4">Service Scope</h2>
              <p className="leading-7 mb-3">
                QBits9 provides AI automation, custom web and mobile development, ERP and business-system integration, desktop and internal software, and related consulting services.
              </p>
              <p className="leading-7">
                All services are described in project proposals and statements of work. We do not guarantee specific business outcomes unless explicitly stated in a signed agreement.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-slate-900 mb-4">Client Responsibilities</h2>
              <p className="leading-7 mb-3">
                Clients agree to provide accurate information, access to systems and data as needed, timely feedback, and decisions required for project delivery.
              </p>
              <p className="leading-7">
                Delays caused by unavailable information, access issues, or other client-side factors may affect project timelines and costs.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-slate-900 mb-4">Payment and Fees</h2>
              <p className="leading-7 mb-3">
                Fees are payable according to the terms agreed in the proposal or contract. Unless otherwise agreed, QBits9 invoices in Indian rupees and expects payment by the due date.
              </p>
              <p className="leading-7">
                Additional work outside the agreed scope may incur extra charges that will be communicated before starting the work.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-slate-900 mb-4">Intellectual Property</h2>
              <p className="leading-7 mb-3">
                Intellectual property rights for deliverables are governed by the signed agreement. Typically, clients receive the rights to use the final software and documentation once payment obligations are satisfied.
              </p>
              <p className="leading-7">
                QBits9 may retain ownership of pre-existing tools, frameworks, and third-party components used in the project.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-slate-900 mb-4">Limitation of Liability</h2>
              <p className="leading-7 mb-3">
                QBits9 is not liable for indirect, special, or consequential damages arising from the use of our services. Our total liability is limited to the amount paid for the relevant services unless otherwise agreed in writing.
              </p>
              <p className="leading-7">
                We strive to deliver reliable work, but no software or automation system can be guaranteed completely error-free.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-slate-900 mb-4">Contact</h2>
              <p className="leading-7">
                For questions about these terms, please email 
                {/* <a href="mailto:hello@qbits9.com" className="text-primary hover:underline">hello@qbits9.com</a>. */}
              </p>
            </section>
          </div>
        </div>
      </section>
    </ServicePageShell>
  );
};

export default TermsOfService;
